import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=1c62315c&"
import script from "./input-textarea.vue?vue&type=script&lang=js&"
export * from "./input-textarea.vue?vue&type=script&lang=js&"
import style0 from "./input-textarea.vue?vue&type=style&index=0&id=1c62315c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports